var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.434 3a1 1 0 01.857.485l2.358 3.931a1 1 0 01-.064 1.124l-8.792 11.429a1 1 0 01-1.586 0h-.001L2.415 8.54a1 1 0 01-.064-1.124l2.358-3.93a1 1 0 01.727-.477L5.566 3h12.868zM11.25 17.564V8.75H4.47l6.78 8.814zm1.5-8.814v8.814l6.78-8.814h-6.78zm4.625-1.5h2.426L18.15 4.5h-2.838l2.062 2.75zm-13.177 0h2.427L8.687 4.5H5.85L4.198 7.25zm4.302 0h7L13.437 4.5h-2.874L8.5 7.25z",
    fill: "currentColor"
  })));
}
SvgBonus.displayName = 'Bonus';
export default SvgBonus;